import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {getStepEntities as getStepEntitiesAPI} from '../../../services/entities/entities'
import fixture from '../../../fixtures/get-step_entities.json'

export async function getStepEntities(dispatch, {field_ids, field_type, object_id}) {
  dispatch({type: PENDING})
  try {
    const response = await getStepEntitiesAPI({field_ids, field_type, object_id})
    // const response = fixture
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Step Entities Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}
